import dehydrationForehead from '../assets/Images/resultLayers/dehydration/forehead.png';
import dehydrationLeftCheek from '../assets/Images/resultLayers/dehydration/left-cheek.png';
import dehydrationRightCheek from '../assets/Images/resultLayers/dehydration/right-cheek.png';
import fatigueHighLeftEye from '../assets/Images/resultLayers/fatigue/high-left-eye.png';
import fatigueHighRightEye from '../assets/Images/resultLayers/fatigue/high-right-eye.png';
import fatigueLowLeftEye from '../assets/Images/resultLayers/fatigue/low-left-eye.png';
import fatigueLowRightEye from '../assets/Images/resultLayers/fatigue/low-right-eye.png';
import fatigueMediumLeftEye from '../assets/Images/resultLayers/fatigue/medium-left-eye.png';
import fatigueMediumRightEye from '../assets/Images/resultLayers/fatigue/medium-right-eye.png';
import lossOfVolumeHighLeftCheek from '../assets/Images/resultLayers/loss-of-volume/high-left-cheek.png';
import lossOfVolumeHighRightCheek from '../assets/Images/resultLayers/loss-of-volume/high-right-cheek.png';
import lossOfVolumeLowLeftCheek from '../assets/Images/resultLayers/loss-of-volume/low-left-cheek.png';
import lossOfVolumeLowRightCheek from '../assets/Images/resultLayers/loss-of-volume/low-right-cheek.png';
import lossOfVolumeMediumLeftCheek from '../assets/Images/resultLayers/loss-of-volume/medium-left-cheek.png';
import lossOfVolumeMediumRightCheek from '../assets/Images/resultLayers/loss-of-volume/medium-right-cheek.png';
import poresUnevenStructureHighCheek from '../assets/Images/resultLayers/pores-uneven-structure/high-cheek.png';
import poresUnevenStructureHighForehead from '../assets/Images/resultLayers/pores-uneven-structure/high-forehead.png';
import poresUnevenStuctureLowCheek from '../assets/Images/resultLayers/pores-uneven-structure/low-cheek.png';
import poresUnvevenStructureLowForehead from '../assets/Images/resultLayers/pores-uneven-structure/low-forehead.png';
import poresUnevenStructureMediumCheek from '../assets/Images/resultLayers/pores-uneven-structure/medium-cheek.png';
import poresUnevenStructureMediumForehead from '../assets/Images/resultLayers/pores-uneven-structure/medium-forehead.png';
import unevenSkinToneHighForehead from '../assets/Images/resultLayers/uneven-skintone/high-forehead.png';
import unevenSkinToneHighLeftCheek from '../assets/Images/resultLayers/uneven-skintone/high-left-cheek.png';
import unevenSkinToneHighRightCheek from '../assets/Images/resultLayers/uneven-skintone/high-right-cheek.png';
import unevenSkinToneLowForehead from '../assets/Images/resultLayers/uneven-skintone/low-forehead.png';
import unevenSkinToneLowLeftCheek from '../assets/Images/resultLayers/uneven-skintone/low-left-cheek.png';
import unevenSkinToneLowRightCheek from '../assets/Images/resultLayers/uneven-skintone/low-right-cheek.png';
import unevenSkinToneMediumForehead from '../assets/Images/resultLayers/uneven-skintone/medium-forehead.png';
import unevenSkinToneMediumLeftCheek from '../assets/Images/resultLayers/uneven-skintone/medium-left-cheek.png';
import unevenSkinToneMediumRightCheek from '../assets/Images/resultLayers/uneven-skintone/medium-right-cheek.png';
import irritationHighRightCheek from '../assets/Images/resultLayers/irritation/high-right-cheek.png';
import irritationHighLeftCheek from '../assets/Images/resultLayers/irritation/high-left-cheek.png';
import irritationLowRightCheek from '../assets/Images/resultLayers/irritation/low-right-cheek.png';
import irritationLowLeftCheek from '../assets/Images/resultLayers/irritation/low-left-cheek.png';
import irritationMediumRightCheek from '../assets/Images/resultLayers/irritation/medium-right-cheek.png';
import irritationMediumLeftCheek from '../assets/Images/resultLayers/irritation/medium-left-cheek.png';
import { Layer } from './../type';

export const LAYERS_PER_CONCERN: { [concern: string]: { [level: string]: Layer[] } } = {
    'blemishes': {
    },
    'uneven_skintone':
    {
        'veryLow': [{
            image: unevenSkinToneLowRightCheek,
            placement: {
                center: {
                    name: 'rightCheek',
                    index: 0,
                    offsetX: -10,
                    offsetY: -25
                },
                size: {
                    width: 60,
                    height: 30
                }
            },
            zoom: 1.32
        }, {
            image: unevenSkinToneLowLeftCheek,
            placement: {
                center: {
                    name: 'leftCheek',
                    index: 0,
                    offsetX: 10,
                    offsetY: -25
                },
                size: {
                    width: 60,
                    height: 30
                }
            },
            zoom: 1.32
        },
        {
            image: unevenSkinToneLowForehead,
            placement: {
                center: {
                    between: [
                        {
                            name: 'rightEyebrowUpper',
                            index: 4
                        },
                        {
                            name: 'leftEyebrowUpper',
                            index: 4
                        }
                    ],
                    offsetY: -45
                },
                size: {
                    width: 120,
                    height: 40
                }
            },
            zoom: 0.96
        },
        ],
        'low': [{
            image: unevenSkinToneLowRightCheek,
            placement: {
                center: {
                    name: 'rightCheek',
                    index: 0,
                    offsetX: -10,
                    offsetY: -25
                },
                size: {
                    width: 60,
                    height: 30
                }
            },
            zoom: 1.32
        }, {
            image: unevenSkinToneLowLeftCheek,
            placement: {
                center: {
                    name: 'leftCheek',
                    index: 0,
                    offsetX: 10,
                    offsetY: -25
                },
                size: {
                    width: 60,
                    height: 30
                }
            },
            zoom: 1.32
        },
        {
            image: unevenSkinToneLowForehead,
            placement: {
                center: {
                    between: [
                        {
                            name: 'rightEyebrowUpper',
                            index: 4
                        },
                        {
                            name: 'leftEyebrowUpper',
                            index: 4
                        }
                    ],
                    offsetY: -45
                },
                size: {
                    width: 120,
                    height: 40
                }
            },
            zoom: 0.96
        },
        ],
        'medium': [{
            image: unevenSkinToneMediumRightCheek,
            placement: {
                center: {
                    name: 'rightCheek',
                    index: 0,
                    offsetX: -10,
                    offsetY: -20
                },
                size: {
                    width: 60,
                    height: 30
                }
            },
            zoom: 1.32
        }, {
            image: unevenSkinToneMediumLeftCheek,
            placement: {
                center: {
                    name: 'leftCheek',
                    index: 0,
                    offsetX: 10,
                    offsetY: -20
                },
                size: {
                    width: 60,
                    height: 30
                }
            },
            zoom: 1.32
        },
        {
            image: unevenSkinToneMediumForehead,
            placement: {
                center: {
                    between: [
                        {
                            name: 'rightEyebrowUpper',
                            index: 4
                        },
                        {
                            name: 'leftEyebrowUpper',
                            index: 4
                        }
                    ],
                    offsetY: -45
                },
                size: {
                    width: 120,
                    height: 20
                }
            },
            zoom: 0.96
        },
        ],
        'high': [{
            image: unevenSkinToneHighRightCheek,
            placement: {
                center: {
                    name: 'rightCheek',
                    index: 0,
                    offsetX: -10,
                    offsetY: -20
                },
                size: {
                    width: 60,
                    height: 30
                }
            },
            zoom: 1.32
        }, {
            image: unevenSkinToneHighLeftCheek,
            placement: {
                center: {
                    name: 'leftCheek',
                    index: 0,
                    offsetX: 10,
                    offsetY: -20
                },
                size: {
                    width: 60,
                    height: 30
                }
            },
            zoom: 1.32
        },
        {
            image: unevenSkinToneHighForehead,
            placement: {
                center: {
                    between: [
                        {
                            name: 'rightEyebrowUpper',
                            index: 4
                        },
                        {
                            name: 'leftEyebrowUpper',
                            index: 4
                        }
                    ],
                    offsetY: -45
                },
                size: {
                    width: 190,
                    height: 40
                }
            },
            zoom: 0.96
        },
        ],
    },
    'irritation':
    {
        'veryLow': [{
            image: irritationLowRightCheek,
            placement: {
                center: {
                    name: 'rightCheek',
                    index: 0,
                    offsetX: 0,
                    offsetY: 0
                },
                size: {
                    width: 60,
                    height: 60
                }
            },
            zoom: 1.2
        }, {
            image: irritationLowLeftCheek,
            placement: {
                center: {
                    name: 'leftCheek',
                    index: 0,
                    offsetX: 0,
                    offsetY: 0
                },
                size: {
                    width: 60,
                    height: 60
                }
            },
            zoom: 1.2
        },
        ],
        'low': [{
            image: irritationLowRightCheek,
            placement: {
                center: {
                    name: 'rightCheek',
                    index: 0,
                    offsetX: 0,
                    offsetY: 0
                },
                size: {
                    width: 60,
                    height: 60
                }
            },
            zoom: 1.2
        }, {
            image: irritationLowLeftCheek,
            placement: {
                center: {
                    name: 'leftCheek',
                    index: 0,
                    offsetX: 0,
                    offsetY: 0
                },
                size: {
                    width: 60,
                    height: 60
                }
            },
            zoom: 1.2
        },
        ],
        'medium': [{
            image: irritationMediumRightCheek,
            placement: {
                center: {
                    name: 'rightCheek',
                    index: 0,
                    offsetX: 0,
                    offsetY: 0
                },
                size: {
                    width: 60,
                    height: 60
                }
            },
            zoom: 1.2
        }, {
            image: irritationMediumLeftCheek,
            placement: {
                center: {
                    name: 'leftCheek',
                    index: 0,
                    offsetX: 0,
                    offsetY: 0
                },
                size: {
                    width: 60,
                    height: 60
                }
            },
            zoom: 1.2
        },
        ],
        'high': [{
            image: irritationHighRightCheek,
            placement: {
                center: {
                    name: 'rightCheek',
                    index: 0,
                    offsetX: 0,
                    offsetY: 0
                },
                size: {
                    width: 60,
                    height: 60
                }
            },
            zoom: 1.2
        }, {
            image: irritationHighLeftCheek,
            placement: {
                center: {
                    name: 'leftCheek',
                    index: 0,
                    offsetX: 0,
                    offsetY: 0
                },
                size: {
                    width: 60,
                    height: 60
                }
            },
            zoom: 1.2
        },
        ],
    },
    'pores_uneven_structure':
    {
        'veryLow': [{
            image: poresUnevenStuctureLowCheek,
            placement: {
                center: {
                    name: 'rightCheek',
                    index: 0,
                    offsetX: -10,
                    offsetY: -25
                },
                size: {
                    width: 60,
                    height: 40
                }
            },
            zoom: 1.32
        }, {
            image: poresUnevenStuctureLowCheek,
            placement: {
                center: {
                    name: 'leftCheek',
                    index: 0,
                    offsetX: 10,
                    offsetY: -25
                },
                size: {
                    width: 60,
                    height: 40
                }
            },
            zoom: 1.32
        },
        {
            image: poresUnevenStuctureLowCheek,
            placement: {
                center: {
                    between: [
                        {
                            name: 'silhouette',
                            index: 20
                        },
                        {
                            name: 'silhouette',
                            index: 16
                        }
                    ],
                    offsetY: 2
                },
                size: {
                    width: 90,
                    height: 30
                }
            }
        },
        {
            image: poresUnvevenStructureLowForehead,
            placement: {
                center: {
                    between: [
                        {
                            name: 'rightEyebrowUpper',
                            index: 4
                        },
                        {
                            name: 'leftEyebrowUpper',
                            index: 4
                        }
                    ],
                    offsetY: -45
                },
                size: {
                    width: 190,
                    height: 50
                }
            }
        },
        ],
        'low': [{
            image: poresUnevenStuctureLowCheek,
            placement: {
                center: {
                    name: 'rightCheek',
                    index: 0,
                    offsetX: -10,
                    offsetY: -25
                },
                size: {
                    width: 60,
                    height: 40
                }
            },
            zoom: 1.32
        }, {
            image: poresUnevenStuctureLowCheek,
            placement: {
                center: {
                    name: 'leftCheek',
                    index: 0,
                    offsetX: 10,
                    offsetY: -25
                },
                size: {
                    width: 60,
                    height: 40
                }
            },
            zoom: 1.32
        },
        {
            image: poresUnevenStuctureLowCheek,
            placement: {
                center: {
                    between: [
                        {
                            name: 'silhouette',
                            index: 20
                        },
                        {
                            name: 'silhouette',
                            index: 16
                        }
                    ],
                    offsetY: 2
                },
                size: {
                    width: 90,
                    height: 30
                }
            }
        },
        {
            image: poresUnvevenStructureLowForehead,
            placement: {
                center: {
                    between: [
                        {
                            name: 'rightEyebrowUpper',
                            index: 4
                        },
                        {
                            name: 'leftEyebrowUpper',
                            index: 4
                        }
                    ],
                    offsetY: -45
                },
                size: {
                    width: 190,
                    height: 50
                }
            }
        },
        ],
        'medium': [{
            image: poresUnevenStructureMediumCheek,
            placement: {
                center: {
                    name: 'rightCheek',
                    index: 0,
                    offsetX: -10,
                    offsetY: -20
                },
                size: {
                    width: 60,
                    height: 50
                }
            },
            zoom: 1.32
        }, {
            image: poresUnevenStructureMediumCheek,
            placement: {
                center: {
                    name: 'leftCheek',
                    index: 0,
                    offsetX: 10,
                    offsetY: -20
                },
                size: {
                    width: 55,
                    height: 50
                }
            },
            zoom: 1.32
        },
        {
            image: poresUnevenStructureMediumCheek,
            placement: {
                center: {
                    between: [
                        {
                            name: 'silhouette',
                            index: 20
                        },
                        {
                            name: 'silhouette',
                            index: 16
                        }
                    ],
                    offsetY: 2
                },
                size: {
                    width: 90,
                    height: 30
                }
            }
        },
        {
            image: poresUnevenStructureMediumForehead,
            placement: {
                center: {
                    between: [
                        {
                            name: 'rightEyebrowUpper',
                            index: 4
                        },
                        {
                            name: 'leftEyebrowUpper',
                            index: 4
                        }
                    ],
                    offsetY: -45
                },
                size: {
                    width: 190,
                    height: 50
                }
            }
        },
        ],
        'high': [{
            image: poresUnevenStructureHighCheek,
            placement: {
                center: {
                    name: 'rightCheek',
                    index: 0,
                    offsetX: -10,
                    offsetY: -20
                },
                size: {
                    width: 80,
                    height: 40
                }
            },
            zoom: 1.32
        }, {
            image: poresUnevenStructureHighCheek,
            placement: {
                center: {
                    name: 'leftCheek',
                    index: 0,
                    offsetX: 10,
                    offsetY: -20
                },
                size: {
                    width: 80,
                    height: 40
                }
            },
            zoom: 1.32
        },
        {
            image: poresUnevenStructureHighCheek,
            placement: {
                center: {
                    between: [
                        {
                            name: 'silhouette',
                            index: 20
                        },
                        {
                            name: 'silhouette',
                            index: 16
                        }
                    ],
                    offsetY: 2
                },
                size: {
                    width: 100,
                    height: 40
                }
            }
        },
        {
            image: poresUnevenStructureHighForehead,
            placement: {
                center: {
                    between: [
                        {
                            name: 'rightEyebrowUpper',
                            index: 4
                        },
                        {
                            name: 'leftEyebrowUpper',
                            index: 4
                        }
                    ],
                    offsetY: -45
                },
                size: {
                    width: 220,
                    height: 50
                }
            },
            zoom: 0.64
        },
        ],
    },
    'loss_of_volume':
    {
        'veryLow': [
            {
                image: lossOfVolumeLowLeftCheek,
                placement: {
                    center: {
                        between: [
                            {
                                name: 'silhouette',
                                index: 25
                            },
                            {
                                name: 'silhouette',
                                index: 19
                            }
                        ],
                        offsetX: 30,
                        offsetY: 40
                    },
                    size: {
                        width: 80,
                        height: 60
                    }
                }
            },
            {
                image: lossOfVolumeLowRightCheek,
                placement: {
                    center: {
                        between: [
                            {
                                name: 'silhouette',
                                index: 11
                            },
                            {
                                name: 'silhouette',
                                index: 17
                            }
                        ],
                        offsetX: -30,
                        offsetY: 40
                    },
                    size: {
                        width: 80,
                        height: 60
                    }
                }
            },
        ],
        'low': [
            {
                image: lossOfVolumeLowLeftCheek,
                placement: {
                    center: {
                        between: [
                            {
                                name: 'silhouette',
                                index: 25
                            },
                            {
                                name: 'silhouette',
                                index: 19
                            }
                        ],
                        offsetX: 30,
                        offsetY: 40
                    },
                    size: {
                        width: 80,
                        height: 60
                    }
                }
            },
            {
                image: lossOfVolumeLowRightCheek,
                placement: {
                    center: {
                        between: [
                            {
                                name: 'silhouette',
                                index: 11
                            },
                            {
                                name: 'silhouette',
                                index: 17
                            }
                        ],
                        offsetX: -30,
                        offsetY: 40
                    },
                    size: {
                        width: 80,
                        height: 60
                    }
                }
            },
        ],
        'medium': [
            {
                image: lossOfVolumeMediumLeftCheek,
                placement: {
                    center: {
                        between: [
                            {
                                name: 'silhouette',
                                index: 25
                            },
                            {
                                name: 'silhouette',
                                index: 19
                            }
                        ],
                        offsetX: 30,
                        offsetY: 40
                    },
                    size: {
                        width: 80,
                        height: 60
                    }
                }
            },
            {
                image: lossOfVolumeMediumRightCheek,
                placement: {
                    center: {
                        between: [
                            {
                                name: 'silhouette',
                                index: 11
                            },
                            {
                                name: 'silhouette',
                                index: 17
                            }
                        ],
                        offsetX: -30,
                        offsetY: 40
                    },
                    size: {
                        width: 80,
                        height: 60
                    }
                }
            },],
        'high': [{
            image: lossOfVolumeHighLeftCheek,
            placement: {
                center: {
                    between: [
                        {
                            name: 'silhouette',
                            index: 25
                        },
                        {
                            name: 'silhouette',
                            index: 19
                        }
                    ],
                    offsetX: 30,
                    offsetY: 40
                },
                size: {
                    width: 80,
                    height: 60
                }
            }
        },
        {
            image: lossOfVolumeHighRightCheek,
            placement: {
                center: {
                    between: [
                        {
                            name: 'silhouette',
                            index: 11
                        },
                        {
                            name: 'silhouette',
                            index: 17
                        }
                    ],
                    offsetX: -30,
                    offsetY: 40
                },
                size: {
                    width: 80,
                    height: 60
                }
            }
        },],
    },
    'dehydration':
    {
        'veryLow': [{
            image: dehydrationRightCheek,
            placement: {
                center: {
                    name: 'rightCheek',
                    index: 0,
                    offsetX: 0,
                    offsetY: 0
                },
                size: {
                    width: 80,
                    height: 80
                }
            },
            opacity: 0.4,
            zoom: 1
        },
        {
            image: dehydrationLeftCheek,
            placement: {
                center: {
                    name: 'leftCheek',
                    index: 0,
                    offsetX: 0,
                    offsetY: 0
                },
                size: {
                    width: 70,
                    height: 80
                }
            },
            opacity: 0.4,
            zoom: 1
        },
        {
            image: dehydrationForehead,
            placement: {
                center: {
                    between: [
                        {
                            name: 'rightEyebrowUpper',
                            index: 4
                        },
                        {
                            name: 'leftEyebrowUpper',
                            index: 4
                        }
                    ],
                    offsetY: -10
                },
                size: {
                    width: 160,
                    height: 60
                }
            },
            opacity: 0.4
        },
        ],
        'low': [{
            image: dehydrationRightCheek,
            placement: {
                center: {
                    name: 'rightCheek',
                    index: 0,
                    offsetX: 0,
                    offsetY: 0
                },
                size: {
                    width: 80,
                    height: 80
                }
            },
            opacity: 0.4,
            zoom: 1
        },
        {
            image: dehydrationLeftCheek,
            placement: {
                center: {
                    name: 'leftCheek',
                    index: 0,
                    offsetX: 0,
                    offsetY: 0
                },
                size: {
                    width: 70,
                    height: 80
                }
            },
            opacity: 0.4,
            zoom: 1
        },
        {
            image: dehydrationForehead,
            placement: {
                center: {
                    between: [
                        {
                            name: 'rightEyebrowUpper',
                            index: 4
                        },
                        {
                            name: 'leftEyebrowUpper',
                            index: 4
                        }
                    ],
                    offsetY: -10
                },
                size: {
                    width: 160,
                    height: 60
                }
            },
            opacity: 0.4
        },
        ],
        'medium': [{
            image: dehydrationRightCheek,
            placement: {
                center: {
                    name: 'rightCheek',
                    index: 0,
                    offsetX: 0,
                    offsetY: 0
                },
                size: {
                    width: 80,
                    height: 80
                }
            },
            opacity: 0.7,
            zoom: 1
        },
        {
            image: dehydrationLeftCheek,
            placement: {
                center: {
                    name: 'leftCheek',
                    index: 0,
                    offsetX: 0,
                    offsetY: 0
                },
                size: {
                    width: 70,
                    height: 80
                }
            },
            opacity: 0.7,
            zoom: 1
        },
        {
            image: dehydrationForehead,
            placement: {
                center: {
                    between: [
                        {
                            name: 'rightEyebrowUpper',
                            index: 4
                        },
                        {
                            name: 'leftEyebrowUpper',
                            index: 4
                        }
                    ],
                    offsetY: -10
                },
                size: {
                    width: 160,
                    height: 60
                }
            },
            opacity: 0.7
        },
        ],
        'high': [{
            image: dehydrationRightCheek,
            placement: {
                center: {
                    name: 'rightCheek',
                    index: 0,
                    offsetX: 0,
                    offsetY: 0
                },
                size: {
                    width: 80,
                    height: 80
                }
            },
            zoom: 1
        },
        {
            image: dehydrationLeftCheek,
            placement: {
                center: {
                    name: 'leftCheek',
                    index: 0,
                    offsetX: 0,
                    offsetY: 0
                },
                size: {
                    width: 70,
                    height: 80
                }
            },
            zoom: 1
        },
        {
            image: dehydrationForehead,
            placement: {
                center: {
                    between: [
                        {
                            name: 'rightEyebrowUpper',
                            index: 4
                        },
                        {
                            name: 'leftEyebrowUpper',
                            index: 4
                        }
                    ],
                    offsetY: -10
                },
                size: {
                    width: 160,
                    height: 60
                }
            }
        },
        ],
    },
    'fatigue':
    {
        'veryLow': [
            {
                image: fatigueLowRightEye,
                placement: {
                    center: {
                        between: [
                            {
                                name: 'rightEyeLower2',
                                index: 0
                            },
                            {
                                name: 'rightEyeLower2',
                                index: 8
                            }
                        ],
                        offsetX: 0,
                        offsetY: 60
                    },
                    size: {
                        width: 95,
                        height: 25
                    }
                },
            },
            {
                image: fatigueLowLeftEye,
                placement: {
                    center: {
                        between: [
                            {
                                name: 'leftEyeLower2',
                                index: 8
                            },
                            {
                                name: 'leftEyeLower2',
                                index: 0
                            }
                        ],
                        offsetX: 0,
                        offsetY: 60
                    },
                    size: {
                        width: 95,
                        height: 25
                    }
                }
            },
        ],
        'low': [
            {
                image: fatigueLowRightEye,
                placement: {
                    center: {
                        between: [
                            {
                                name: 'rightEyeLower2',
                                index: 0
                            },
                            {
                                name: 'rightEyeLower2',
                                index: 8
                            }
                        ],
                        offsetX: 0,
                        offsetY: 60
                    },
                    size: {
                        width: 95,
                        height: 25
                    }
                }
            },
            {
                image: fatigueLowLeftEye,
                placement: {
                    center: {
                        between: [
                            {
                                name: 'leftEyeLower2',
                                index: 8
                            },
                            {
                                name: 'leftEyeLower2',
                                index: 0
                            }
                        ],
                        offsetX: 0,
                        offsetY: 60
                    },
                    size: {
                        width: 95,
                        height: 25
                    }
                }
            },
        ],
        'medium': [
            {
                image: fatigueMediumRightEye,
                placement: {
                    center: {
                        between: [
                            {
                                name: 'rightEyeLower2',
                                index: 0
                            },
                            {
                                name: 'rightEyeLower2',
                                index: 8
                            }
                        ],
                        offsetX: 0,
                        offsetY: 60
                    },
                    size: {
                        width: 95,
                        height: 25
                    }
                }
            },
            {
                image: fatigueMediumLeftEye,
                placement: {
                    center: {
                        between: [
                            {
                                name: 'leftEyeLower2',
                                index: 8
                            },
                            {
                                name: 'leftEyeLower2',
                                index: 0
                            }
                        ],
                        offsetX: 0,
                        offsetY: 60
                    },
                    size: {
                        width: 95,
                        height: 25
                    }
                }
            },
        ],
        'high': [
            {
                image: fatigueHighRightEye,
                placement: {
                    center: {
                        between: [
                            {
                                name: 'rightEyeLower2',
                                index: 0
                            },
                            {
                                name: 'rightEyeLower2',
                                index: 8
                            }
                        ],
                        offsetX: 0,
                        offsetY: 60
                    },
                    size: {
                        width: 95,
                        height: 25
                    }
                }
            },
            {
                image: fatigueHighLeftEye,
                placement: {
                    center: {
                        between: [
                            {
                                name: 'leftEyeLower2',
                                index: 8
                            },
                            {
                                name: 'leftEyeLower2',
                                index: 0
                            }
                        ],
                        offsetX: 0,
                        offsetY: 60
                    },
                    size: {
                        width: 95,
                        height: 25
                    }
                }
            },
        ],
    },
}
